import { Row } from '@/components/layout/layout'
import { getBEMCls } from '@/utils/classname'
import classNames from 'classnames'
import { observer } from 'mobx-react'
import React from 'react'
import { GoodsModel } from '../model'
import Select from '../../../../../../../../../../components/input/select'
import { useField } from 'formik'
import { showLayer } from '@/utils/layer'
import { Select as AntSelect } from 'formik-antd'
import ChooseGoodsSupplierDialog from '../supplier/supplier'

export const GoodsSupplierFormItem: React.FC<{
    goodsModel: GoodsModel
}> = observer(props => {
    const [field, , helpers] = useField('supplier_ids')
    const cls = (...args: string[]) => getBEMCls('edit-goods', ...args)

    return (
        <Row data-position-relative data-align-items-center data-padding-h-24>
            <span className={classNames(cls('form-item', 'title'))}>供货商</span>
            <Select
                name="supplier_ids"
                mode="multiple"
                showSearch
                maxTagCount={3}
                placeholder="输入名称/手机号搜索供货商"
                inputsuffix={() => (
                    <span
                        data-cursor-pointer
                        data-font-size-14
                        data-color-000
                        onClick={() => {
                            showLayer(
                                <ChooseGoodsSupplierDialog
                                    selectSuplierIds={field.value}
                                    // goodsModel={props.goodsModel}
                                    onSelected={item => {
                                        helpers.setValue(item.map(val => val.id))
                                    }}
                                ></ChooseGoodsSupplierDialog>,
                            )
                        }}
                    >
                        供货商列表
                        <i data-color-999 className="iconfont icon6youjiantou-20"></i>
                    </span>
                )}
            >
                {props.goodsModel.supplier.map(val => {
                    return (
                        <AntSelect.Option key={val.id} value={val.id}>
                            {val.name}
                        </AntSelect.Option>
                    )
                })}
            </Select>
        </Row>
    )
})
